export const convertOptions = options => {
  // eslint-disable-line
  const layout = [];
  const sameKeys = ['label'];
  const mapping = {
    value: 'data',
  };

  if (!options || !Array.isArray(options)) {
    console.warn('Empty options', options);
    return layout;
  }

  options.forEach((option, index) => {
    const field = {};
    // Do same keys
    sameKeys.forEach(k => {
      field[k] = option[k];
    });

    // Do mapping
    Object.keys(option).forEach(k => {
      if (mapping[k]) {
        field[mapping[k]] = option[k];
      }
    });

    // Do name
    // field.name = option.label ? camelize(option.label) : `field-${index}`;
    field.name = String(index);

    // Do options
    if (option.options && option.type !== 'search') {
      field.noEmptyOption = true;
      field.options = Object.keys(option.options).map(o => {
        return { label: o, value: String(option.options[o]) };
      });
    }

    if (option.validators) {
      Object.keys(option.validators).forEach(v => {
        if (v === 'required' || v === 'pattern') {
          field[v] = option.validators[v];
        }
      });
    }

    if (option.dynamic) {
      const name = option.dynamic.options.shift();
      field.validation = {
        list: {
          method: {
            program: option.dynamic.program,
            name,
            keys: option.dynamic.options,
          },
        },
      };
    }

    if (option.type) {
      switch (option.type) {
        case 'hidden':
          field.hidden = true;
          break;
        case 'date':
          field.type = 'json';
          field.control = 'runtimedate';
          break;
        case 'number':
          // Making this a number in BlazeForm by default will commaify and report
          // uses 'number' for years.  So can't use currently.
          // field.type = 'number';
          break;
        case 'search':
          field.validation = {
            page: option.options.list,
            optional: option.options.freeinput,
          };
          field.control = option.options.multiselect ? 'tags' : 'search';
          break;
        case 'boolean':
          field.control = 'checkbox';
          break;
        default:
        // nothing
      }
    }

    layout.push(field);
  });

  return layout;
};

export const hasInput = options => {
  for (const option of options) {
    for (const key of Object.keys(option)) {
      if (key === 'type' && option[key] === 'hidden') {
        break;
      }

      return true;
    }
  }

  return false;
};
